import Route from '@ember/routing/route'
import { service } from '@ember/service'
import { all } from 'rsvp'
import type Store from '@ember-data/store'
import type SessionService from 'teacher-ui-client/services/session'
import type Teacher from 'teacher-ui-client/models/teacher'
import type SchoolClass from 'teacher-ui-client/models/school-class'

export type ManageClassesModel = ModelFor<ManageClassesRoute>

export default class ManageClassesRoute extends Route {
  @service session!: SessionService

  @service store!: Store

  queryParams = {
    sortCol: {
      replace: true,
    },
    sortDir: {
      replace: true,
    },
    sortCompare: {
      replace: true,
    },
    currentPage: {
      replace: true,
    },
    textFilter: {
      replace: true,
    },
    teacherFilter: {
      replace: true,
    },
    recordsPerPage: {
      replace: true,
    },
  }

  buildRouteInfoMetadata() {
    return {
      rolloverLock: {
        subco: {
          lockOtherSubscriptionType: true,
        },
        teacher: {
          lockCurrentSubscriptionType: true,
          lockOtherSubscriptionType: true,
        },
      },
    }
  }

  async model() {
    const { subscriptionUtilisation, subscriptionType } = this.modelFor(
      'subscription-type',
    ) as ModelForSubscriptionTypeRoute
    const isSubco = this.session.currentTeacher.subcoFor(subscriptionType)
    const [teachers, allSchoolClasses] = await all([
      this.store.query<Teacher>('teacher', {
        // @ts-expect-error - include types not correct
        include: 'teacher-subscriptions',
      }),
      this.store.query<SchoolClass>('school-class', {
        // @ts-expect-error - include types not correct
        include: ['teachers', 'students'].join(','),
      }),
    ])

    return {
      isSubco,
      allSchoolClasses,
      subscriptionType,
      subscriptionUtilisation,
      teachers,
    }
  }
}
